import { render } from "./AlertPreview.vue?vue&type=template&id=8ce32a86&scoped=true&ts=true"
import script from "./AlertPreview.vue?vue&type=script&lang=ts"
export * from "./AlertPreview.vue?vue&type=script&lang=ts"

import "./AlertPreview.vue?vue&type=style&index=0&id=8ce32a86&scoped=true&lang=css"

import exportComponent from "/srv/zpp/var/code/p-kunden.nsl.software/node-kunden-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ce32a86"]])

export default __exports__